import { Question } from '@/models/Question';
import { Person } from '@/models/Person';

export class QuestionSelectFace extends Question {

  constructor(public person: Person) {
    super();
  }

  getComponent(): string {
    return 'SelectFace';
  }
}
